import { render, staticRenderFns } from "./addIntegral.vue?vue&type=template&id=2e9ddfe4&scoped=true&"
import script from "./addIntegral.vue?vue&type=script&lang=js&"
export * from "./addIntegral.vue?vue&type=script&lang=js&"
import style0 from "./addIntegral.vue?vue&type=style&index=0&id=2e9ddfe4&lang=scss&scoped=true&"
import style1 from "./addIntegral.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ddfe4",
  null
  
)

export default component.exports